<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Customers</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }" v-if="$store.state.currentPagePriv.create">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="newItem">
                      New Customer
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Code</span>
                            <v-text-field maxlength="10" v-model="editedItem.code" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="viewMode || editedIndex>-1" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Customer Name</span>
                            <v-text-field v-model="editedItem.customer_name" filled rounded dense hide-details="auto" :readonly="viewMode" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Address</span>
                            <v-text-field v-model="editedItem.address" filled rounded dense hide-details="auto" :readonly="viewMode" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Category</span>
                            <v-select :items="customerCategory" item-text="description" item-value="code" v-model="editedItem.category" filled rounded dense hide-details="auto" :readonly="viewMode" :rules="reqRule"></v-select>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6">
                            <span>Driver Route</span>
                            <v-select :items="driverRoute" item-text="description" item-value="code" v-model="editedItem.driver_route" filled rounded dense hide-details="auto" :rules="reqRule"></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="6">
                            <span>Status</span>
                            <v-checkbox v-model="editedItem.status" :disabled="viewMode"></v-checkbox>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        {{ viewMode ? 'Close' : 'Cancel' }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save" v-if="!viewMode">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus customer ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      viewMode: false,
      headers: [
        { text: 'Code', value: 'code' },
        { text: 'Customer Name', value: 'customer_name' },
        { text: 'Category', value: 'category' },
        // { text: 'Driver Route', value: 'driver_route' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        driver_route: 'A1',
        status: true
      },
      defaultItem: {
        driver_route: 'A1',
        status: true
      },
      search: '',
      reqRule: [v => !!v || 'Harus diisi!'],
      valid: true,
      driverRoute: [],
      customerCategory: []
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Customer' : `${this.viewMode ? 'View' : 'Edit'} Customer`
      },
      miscCodes() {
        return this.$store.state.misccode.objs
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        let response = await this.$store.dispatch('customer/getObjs')
        if (response.data.status=='success') this.items = response.data.data
        this.driverRoute = this.miscCodes.filter(element => {
          return element.type=='Driver Route'
        })
        this.customerCategory = this.miscCodes.filter(element => {
          return element.type=='Customer Category'
        })
        this.driverRoute.sort((a, b) => parseFloat(a.code) - parseFloat(b.code));

      },

      viewItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.viewMode = true
        this.dialog = true
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.viewMode = false
        this.dialog = true
      },

      newItem () {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.viewMode = false
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "customers/" + this.editedItem.code
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.viewMode = false
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "customers/" + this.editedItem.code
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem)
          this.close()
          
        } else {
          try {
            let url = this.$store.state.config.apiHost + "customers"
            let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success') this.items.push(this.editedItem)
            this.close()
          }
          catch (err) {
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>